const controls = [
  { name: 'Domain validation', state: 'Ready', detail: 'Canonical records and state transitions' },
  {
    name: 'Synthetic dry runs',
    state: '10 / 10 passed',
    detail: 'CI-enforced acceptance scenarios',
  },
  {
    name: 'Authorization controls',
    state: 'Model ready',
    detail: 'Deny by default, separation of duties, and audited emergency access',
  },
  {
    name: 'Authentication',
    state: 'Not connected',
    detail: 'Provider decision intentionally pending',
  },
  { name: 'Real-data gate', state: 'Closed', detail: 'Production records remain prohibited' },
];

export function ControlReadiness() {
  return (
    <section className="readiness-section" aria-labelledby="readiness-heading">
      <div>
        <p className="eyebrow">Security boundary</p>
        <h2 id="readiness-heading">Foundation readiness</h2>
      </div>
      <div className="control-list">
        {controls.map((control) => (
          <article key={control.name}>
            <div>
              <strong>{control.name}</strong>
              <p>{control.detail}</p>
            </div>
            <span>{control.state}</span>
          </article>
        ))}
      </div>
    </section>
  );
}
